import gql from "graphql-tag"

const query = gql`
  query DealStockCountByUrlSlug($urlSlug: String!) {
    dealStockCountByUrlSlug(urlSlug: $urlSlug) {
      allOutOfStock
      stockTotals {
        id
        count
      }
    }
  }
`

export const toString = query.loc.source.body

export default query
